import axios from 'axios';
import config from '../config';
import { store } from '../store';
import { refreshTokenThunk } from '../store/authThunks';
import { logout } from '../store/authSlice';
import { isTokenValid } from '../utils/authUtils';

const api = axios.create({
  baseURL: config.API_URL,
});

api.interceptors.request.use(
  async (config) => {
    const state = store.getState().auth;

    if (!isTokenValid(state)) {
      try {
        if (!state.refreshToken) {
          console.error('Refresh token is missing. Logging out...');
          store.dispatch(logout());
          return Promise.reject(new Error('No refresh token available'));
        }

        await store.dispatch(refreshTokenThunk(state.refreshToken));
        const updatedState = store.getState().auth;

        if (updatedState.token) {
          config.headers.Authorization = `Bearer ${updatedState.token}`;
        }
      } catch (error) {
        console.error('Failed to refresh token:', error);
        store.dispatch(logout());
        return Promise.reject(error);
      }
    } else if (state.token) {
      config.headers.Authorization = `Bearer ${state.token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    console.log('API Response:', response);
    return response;
  },
  async (error) => {
    console.error('API Error:', error);

    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const state = store.getState().auth;

      try {
        if (!state.refreshToken) {
          console.error('Refresh token is missing. Logging out...');
          store.dispatch(logout());
          return Promise.reject(new Error('No refresh token available'));
        }

        await store.dispatch(refreshTokenThunk(state.refreshToken));
        const updatedState = store.getState().auth;

        if (updatedState.token) {
          originalRequest.headers.Authorization = `Bearer ${updatedState.token}`;
          return api(originalRequest);
        }
      } catch (refreshError) {
        console.error('Refresh token error:', refreshError);
        store.dispatch(logout());
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;